import { forwardRef, useContext, useEffect, useImperativeHandle, useState } from "react";
import { DataTable } from "primereact/datatable";
import { useAPIGetPengisianMinyak } from "../api/api-get-pengisian-minyak";
import { Column } from "primereact/column";
import PengisianMinyakFilter from "./pengisian-minyak-filter";
import {
  genTemplateBodyDateTime,
  genTemplateBodyNumber,
  genTemplateBodyText,
} from "../../../components/utils/TableTemplateBodyGenerator";
import { Paginator } from "primereact/paginator";
import { Button } from "primereact/button";
import { format } from "date-fns";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../store/ui-context";
import { useSelector } from "react-redux";
import { useAPIEditPengisianMinyak } from "../api/api-edit-pengisian-minyak";
import SignatureButton from "../../../components/signature-button/SignatureButton";
import PengisianMinyakImagePreview from "./pengisian-minyak-image-preview";
import useIsMobile from "../../../hooks/useIsMobile";


const defaultVerifSettingPengecekan = {
  jabatan_id: -1,
  admin: [],
};

const PengisianMinyakList = forwardRef((props, ref) => {
  const isMobile = useIsMobile();
  const { onClickRowDelete, onClickRowEdit, onClickAddNew, onConfirmed } = props;

  const {
    loading,
    listData,
    listDataNotVerify,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    pagingNotVerify,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
  } = useAPIGetPengisianMinyak();

  const {
    data,
    setData,
  } = useAPIEditPengisianMinyak({ onConfirmed });

  useImperativeHandle(ref, () => ({
    handleOnUpdateViewRow: (row) => {
      handleOnUpdateViewRow(row);
    },
    handleOnDeleteViewRow: (row) => {
      handleOnDeleteViewRow(row);
    },
  }));

  const [verifSettingPengecekan, setVerifSettingPengecekan] = useState({
    ...defaultVerifSettingPengecekan,
  });

  const [showImagePreview, setShowImagePreview] = useState(false);
  const [imagePreviewData, setImagePreviewData] = useState(null);

  const handleOnClickRowImage = (row) => {
    setImagePreviewData(row);
    setShowImagePreview(true);
  };

  const { requestGet, requestPost } =
    useAPIRequest();
  const uiContext = useContext(UiContext);
  const employee = useSelector((state) => state.auth.employee);

  // use effect section

  useEffect(() => {
    fetchVerifSettingPengecekan();
    fetchListData({ page: paging.page, take: paging.take });
  }, []);

  //  custom ui section

  const fetchVerifSettingPengecekan = async () => {
    requestGet({
      fullUrl: "/api/masterdata/verifsetting/data",
      params: { filter: `label:contains:pengisian_minyak%` },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        if (data && data.length > 0) {
          const newVerifSetting = {
            ...defaultVerifSettingPengecekan,
            jabatan_id: employee.jabatan_id,
          };
          if (data) {
            for (const verifData of data) {
              const { id, label, jabatan_id } = verifData;
              const newVerifLabel = label
                .replace(`pengisian_minyak:`, "")
                .trim();
              newVerifSetting[newVerifLabel].push(jabatan_id);
            }
          }
          setVerifSettingPengecekan(newVerifSetting);
        }
      },
    });
  };

  const verify = async ({
    username,
    password,
    verifLabel,
    id,
    result_object_id,
    result_object_datetime,
    result_object_data,
    data,
    setData,
  }) => {
    const body = { data_id: id, label: verifLabel };
    if (username) body["username"] = username;
    if (password) body["password"] = password;

    // console.log("VERIF", body);

    return await requestPost({
      fullUrl: `/api/user/verif`,
      body: body,
      onSuccess: ({ message, data: responseData }) => {
        if (responseData) {
          const newData = { ...data };
          newData[result_object_id] = responseData[result_object_id];
          newData[result_object_datetime] =
            responseData[result_object_datetime];
          newData[result_object_data] = responseData[result_object_data];
          setData(newData);

          uiContext.showSuccessMsg("Success", "Verifikasi berhasil");
          handleOnClickRefresh();
        }
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  const handleOnSignDicekAdminKembali = async (props) => {
    let username = undefined;
    let password = undefined;

    if (props && props.username) {
      username = props.username;
    }

    if (props && props.password) {
      password = props.password;
    }

    const verifyResponse = await verify({
      username,
      password,
      label: "admin",
      verifLabel: "pengisian_minyak:admin",
      id: props.id,
      result_object_id: "verif_admin_id",
      result_object_datetime: "verif_admin_datetime",
      result_object_data: "data_verif_admin",
      data: data,
      setData: setData,
    });

    return verifyResponse;
  };

  const tanggalBodyTemplate = (row) => {
    return genTemplateBodyDateTime({
      row: row,
      field: "tanggal_transaksi",
    });
  };

  const kendaraanBodyTemplate = (row) => {
    return genTemplateBodyText({
      row: row,
      field: "data_kendaraan.nomor_polisi",
    });
  };

  const jenisBodyTemplate = (row) => {
    return genTemplateBodyText({
      row: row,
      field: "data_jenis_minyak.nama",
    });
  };
  const userBodyTemplate = (row) => {
    const { edit_by, input_by } = row;

    if (input_by && edit_by && input_by === edit_by) {
      // same → show once
      return (
        <div className="flex flex-col text-sm text-gray-700">
          <span>
            <strong>Input By:</strong> {input_by}
          </span>
        </div>
      );
    }

    // different → show both stacked with labels
    return (
      <div className="flex flex-col text-sm text-gray-700">
        {input_by && (
          <span>
            <strong>Input By: </strong> {input_by}
          </span>
        )}
        {edit_by && (
          <span>
            <strong>Edit By: </strong> {edit_by}
          </span>
        )}
      </div>
    );
  };

  const jumlahBodyTemplate = (row) => {
    return genTemplateBodyNumber({
      row: row,
      field: "jumlah",
    });
  };

  const speedometerAkhirBodyTemplate = (row) => {
    return genTemplateBodyNumber({
      row: row,
      field: "speedo_akhir",
    });
  };

  const totalHargaBodyTemplate = (row) => {
    return genTemplateBodyNumber({
      row: row,
      field: "total_harga",
    });
  };

  const verifyBodyTemplate = (row) => {

    if (row.verif_admin_id !== null) {
      return (
        <div className="col-center-center gap-1">
          {row.verif_admin_id && (
            <>
              <i className="pi pi-verified text-xl text-blue-500" />
              <span
                type="button"
                className="text-sm text-blue-700 text-center"
                disabled
              >
                {row.data_verif_admin?.nama || "Admin"}
              </span>
            </>
          )}
        </div>
      );
    }

    return (
      <SignatureButton
        // disabled={(headerData.id ? false : true) || isBerangkat}
        className="max-h-[2rem] !px-4 bg-emerald-500 border-emerald-500"
        rounded={true}
        label="admin"
        title="Admin"
        fieldId="verif_admin_id"
        fieldData="data_verif_admin"
        fieldDatetime="verif_admin_datetime"
        verifField="pengisian_minyak:admin"
        jabatanId={verifSettingPengecekan.jabatan_id}
        jabatanIdRequirement={verifSettingPengecekan["admin"]}
        field="verif_admin_id"
        data={data}
        onConfirm={(props) => {
          const newProps = props ? props : {};
          newProps["id"] = row.id;
          handleOnSignDicekAdminKembali(newProps);
        }}
      // onValidate={handleValidateDibukukan}
      />
    );
  };

  const actionBodyTemplate = (row) => {
    return (
      <div className="row-center-center gap-2">
        <Button
          icon={row.id && row.id > 0 ? "pi pi-pencil" : "pi pi-plus"}
          rounded
          severity={row.id && row.id > 0 ? "primary" : "success"}
          className={`${row.id && row.id > 0 ? "bg-indigo-400" : "bg-emerald-400"
            } max-w-[1.85rem] max-h-[1.85rem]`}
          onClick={() => {
            if (onClickRowEdit) onClickRowEdit(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
          disabled={!!row.data_verif_admin}
        />
        <Button
          icon="pi pi-image"
          rounded
          severity="info"
          className="bg-sky-400 border-sky-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            handleOnClickRowImage(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
        <Button
          icon="pi pi-trash"
          rounded
          severity="danger"
          className="bg-red-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onClickRowDelete) onClickRowDelete(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
          disabled={!!row.data_verif_admin}
        />
      </div>
    );
  };

  const mobileBodyTemplate = (row) => {
    const {
      no,
      tanggal_transaksi,
      data_kendaraan,
      data_jenis_minyak,
      speedo_akhir,
      total_harga,
      edit_by,
      input_by,
    } = row;

    return (
      <div className="col-start-start pb-1">

        <span className="text-semibold text-slate-400 text-sm">#{no}</span>
        <span className="row-start-center gap-2 pt-2">
          <span className="font-bold text-slate-400 text-lg">
            {data_kendaraan?.nomor_polisi}
          </span>
          <span className="text-slate-400 text-sm">|</span>
          <span className="font-bold text-slate-400 text-sm">
            {data_jenis_minyak?.nama ?? "-"}
          </span>
        </span>
        <div className="row-start-center w-full gap-2 pt-2">
          <i className="pi pi-calendar text-slate-400" />
          <span className="text-slate-500 text-sm">
            {format(new Date(tanggal_transaksi), "dd/MM/yyyy HH:mm")}
          </span>
        </div>
        <div className="row-start-center w-full gap-2 pt-2">
          <i className="pi pi-gauge text-slate-400" />
          <span className="text-slate-500 text-sm">
            {speedo_akhir?.toLocaleString("id-ID")} KM
          </span>
        </div>
        <div className="row-start-center w-full gap-2 pt-2">
          <i className="pi pi-dollar text-slate-400" />
          <span className="text-slate-500 text-sm">
            Rp.{total_harga?.toLocaleString("id-ID")}
          </span>
        </div>
        <div className="col-start-start w-full gap-2 pt-2">
          {input_by && edit_by && input_by === edit_by ? (
            // --- Same user → show only Input By ---
            <div className="row-start-center w-full gap-2">
              <i className="pi pi-file-edit text-slate-400" />
              <span className="text-slate-500 text-sm">
                <strong>Input By:</strong> {input_by}
              </span>
            </div>
          ) : (
            // --- Different users → show both ---
            <>
              {input_by && (
                <div className="row-start-center w-full gap-2">
                  <i className="pi pi-file-edit text-slate-400" />
                  <span className="text-slate-500 text-sm">
                    <strong>Input By:</strong> {input_by}
                  </span>
                </div>
              )}
              {edit_by && (
                <div className="row-start-center w-full gap-2">
                  <i className="pi pi-pencil text-slate-400" />
                  <span className="text-slate-500 text-sm">
                    <strong>Edit By:</strong> {edit_by}
                  </span>
                </div>
              )}
            </>
          )}
        </div>
        <div className="row-between-center w-full gap-2 pt-2">
          <div className="row-start-center gap-2">
            {!row.data_verif_admin && (
              <>
                <Button
                  icon={row.id && row.id > 0 ? "pi pi-pencil" : "pi pi-plus"}
                  label="Edit"
                  rounded
                  severity={row.id && row.id > 0 ? "primary" : "success"}
                  className={`${row.id && row.id > 0 ? "bg-indigo-400" : "bg-emerald-400"
                    } max-h-[2rem] !px-4`}
                  onClick={() => {
                    if (onClickRowEdit) onClickRowEdit(row);
                  }}
                  pt={{ icon: { className: "!text-xs" } }}
                />
                <SignatureButton
                  // disabled={(headerData.id ? false : true) || isBerangkat}
                  className="max-h-[2rem] !px-4 bg-emerald-500 border-emerald-500"
                  rounded={true}
                  label="Admin"
                  title="Admin"
                  fieldId="verif_admin_id"
                  fieldData="data_verif_admin"
                  fieldDatetime="verif_admin_datetime"
                  verifField="pengisian_minyak:admin"
                  jabatanId={verifSettingPengecekan.jabatan_id}
                  jabatanIdRequirement={verifSettingPengecekan["admin"]}
                  field="verif_admin_id"
                  data={data}
                  onConfirm={(props) => {
                    const newProps = props ? props : {};
                    newProps["id"] = row.id;
                    handleOnSignDicekAdminKembali(newProps);
                  }}
                // onValidate={handleValidateDibukukan}
                />
              </>
            )}
          </div>
          {row.data_verif_admin && (
            <div className="row-start-center w-full gap-2">
              <i className="pi pi-verified text-blue-500" />
              <span className="text-slate-500 text-sm">
                Verified by {row.data_verif_admin?.nama ?? "Admin"}
              </span>
            </div>
          )}
          <div className="row-center-center gap-2">
            <Button
              icon="pi pi-image"
              rounded
              severity="info"
              className="bg-sky-400 border-sky-400 max-w-[2rem] max-h-[2rem]"
              onClick={() => {
                handleOnClickRowImage(row);
              }}
              pt={{ icon: { className: "!text-xs" } }}
            />
            <Button
              icon="pi pi-trash"
              rounded
              severity="danger"
              className="bg-red-400 max-w-[2rem] max-h-[2rem]"
              onClick={() => {
                if (onClickRowDelete) onClickRowDelete(row);
              }}
              pt={{ icon: { className: "!text-xs" } }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="col-start-start w-full gap-4">
      <PengisianMinyakImagePreview
        visible={showImagePreview}
        data={imagePreviewData}
        onHide={() => setShowImagePreview(false)}
      />

      {/* filter section */}
      <div className="elevated-card-tight-vertical row-start-start w-full gap-4">
        <PengisianMinyakFilter
          filterValue={filterValue}
          setFilterValue={setFilterValue}
          onClickRefresh={handleOnClickRefresh}
        />
      </div>

      {/* table section */}
      <div className={`elevated-card-tight-vertical ${isMobile ? "col-start-center" : "col-start-end"} w-full gap-2`}>
        <div className="row-between-center w-full">
          <span className="font-bold text-lg text-red-600">Belum Diverifikasi</span>
          <Button
            icon="pi pi-plus"
            label="Tambah Baru"
            onClick={() => {
              if (onClickAddNew) onClickAddNew();
            }}
          />
        </div>

        {!isMobile && (
          <>
            <DataTable
              dataKey="id"
              className="w-100"
              loading={loading}
              showGridlines
              stripedRows
              value={listDataNotVerify}
            >
              <Column
                field="no"
                header="#"
                className="text-center"
                headerClassName="w-[4rem]"
                alignHeader={"center"}
              />
              <Column
                field=""
                header="Action"
                alignHeader={"center"}
                headerClassName="w-[8rem]"
                body={actionBodyTemplate}
              />
              <Column header="Tanggal" body={tanggalBodyTemplate} />
              <Column header="Nomor Plat" body={kendaraanBodyTemplate} />
              <Column header="Jenis" body={jenisBodyTemplate} />
              <Column align={"right"} header="Jumlah" body={jumlahBodyTemplate} />
              <Column
                align={"right"}
                header="KM Akhir"
                body={speedometerAkhirBodyTemplate}
              />
              <Column
                align={"right"}
                header="Harga"
                body={totalHargaBodyTemplate}
              />
              <Column
                align={"right"}
                header="Input"
                body={userBodyTemplate}
              />
              <Column
                align={"right"}
                header="Verify"
                body={verifyBodyTemplate}
              />
            </DataTable>
            {/* <Paginator
              first={parseInt(pagingNotVerify.take) * (pagingNotVerify.page - 1)}
              rows={parseInt(pagingNotVerify.take)}
              totalRecords={parseInt(pagingNotVerify.total)}
              rowsPerPageOptions={[5, 10, 20, 50]}
              onPageChange={handleOnPage}
            /> */}
          </>
        )}
        {isMobile && (
          <>
            <DataTable
              dataKey="id"
              className="w-100"
              loading={loading}
              showGridlines
              stripedRows
              value={listDataNotVerify}
            >
              <Column
                header="Deskripsi Pengisian Minyak"
                body={mobileBodyTemplate}
              />
            </DataTable>
            {/* <Paginator
              first={parseInt(pagingNotVerify.take) * (pagingNotVerify.page - 1)}
              rows={parseInt(pagingNotVerify.take)}
              totalRecords={parseInt(pagingNotVerify.total)}
              rowsPerPageOptions={[5, 10, 20, 50]}
              template={{
                layout: "PrevPageLink CurrentPageReport NextPageLink",
              }}
              onPageChange={handleOnPage}
              pt={{
                prevPageButton: {
                  className:
                    "bg-white-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
                },
                nextPageButton: {
                  className:
                    "bg-white-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
                },
                current: {
                  className: "bg-white-100 !m-0 max-h-[22px] text-sm",
                },
              }}
            /> */}
          </>
        )}
      </div>
      <div className={`elevated-card-tight-vertical ${isMobile ? "col-start-center" : "col-start-end"} w-full gap-2`}>
        <div className="row-start-center w-full">
          <span className="font-bold text-lg text-green-600">Sudah Diverifikasi</span>
        </div>

        {!isMobile && (
          <>
            <DataTable
              dataKey="id"
              className="w-100"
              loading={loading}
              showGridlines
              stripedRows
              value={listData}
            >
              <Column
                field="no"
                header="#"
                className="text-center"
                headerClassName="w-[4rem]"
                alignHeader={"center"}
              />
              <Column
                field=""
                header="Action"
                alignHeader={"center"}
                headerClassName="w-[8rem]"
                body={actionBodyTemplate}
              />
              <Column header="Tanggal" body={tanggalBodyTemplate} />
              <Column header="Nomor Plat" body={kendaraanBodyTemplate} />
              <Column header="Jenis" body={jenisBodyTemplate} />
              <Column align={"right"} header="Jumlah" body={jumlahBodyTemplate} />
              <Column
                align={"right"}
                header="KM Akhir"
                body={speedometerAkhirBodyTemplate}
              />
              <Column
                align={"right"}
                header="Harga"
                body={totalHargaBodyTemplate}
              />
              <Column
                align={"right"}
                header="Input"
                body={userBodyTemplate}
              />
              <Column
                align={"right"}
                header="Verify"
                body={verifyBodyTemplate}
              />
            </DataTable>
            <Paginator
              first={parseInt(paging.take) * (paging.page - 1)}
              rows={parseInt(paging.take)}
              totalRecords={parseInt(paging.total)}
              rowsPerPageOptions={[5, 10, 20, 50]}
              onPageChange={handleOnPage}
            />
          </>
        )}
        {isMobile && (
          <>
            <DataTable
              dataKey="id"
              className="w-100"
              loading={loading}
              showGridlines
              stripedRows
              value={listData}
            >
              <Column
                header="Deskripsi Pengisian Minyak"
                body={mobileBodyTemplate}
              />
            </DataTable>
            <Paginator
              first={parseInt(paging.take) * (paging.page - 1)}
              rows={parseInt(paging.take)}
              totalRecords={parseInt(paging.total)}
              rowsPerPageOptions={[5, 10, 20, 50]}
              template={{
                layout: "PrevPageLink CurrentPageReport NextPageLink",
              }}
              onPageChange={handleOnPage}
              pt={{
                prevPageButton: {
                  className:
                    "bg-white-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
                },
                nextPageButton: {
                  className:
                    "bg-white-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
                },
                current: {
                  className: "bg-white-100 !m-0 max-h-[22px] text-sm",
                },
              }}
            />
          </>
        )}
      </div>
    </div>
  );
});

export default PengisianMinyakList;
